import api from '@/utils/api'

export default {
    getAllSports(page = 1, size = 0, title = '') {
        const params = [`page=${page}`, `per_page=${size}`]
        if (title) {
            params.push(`title=${encodeURIComponent(title)}`)
        }

        return api.get(`sport/all?${params.join('&')}`)
    },
    getSport(id) {
        return api.get(`sport/${id}`)
    }
}
